/**
 * Import Dependency
 */
import { createAction } from 'redux-actions'
import {
  SET_TAKEAWAY_WAITING_BASKET,
} from '../../constants/actionType'
// import user from '../../services/api/user'

/**
 * Declare Variable
 */
const setTakeawayWaitingBasketAction = createAction(SET_TAKEAWAY_WAITING_BASKET)

/**
 * Export
 */
export const setTakeawayWaitingBasket = (value) => async (dispatch) => {
  try {
    dispatch(setTakeawayWaitingBasketAction(value))
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}



// WEBPACK FOOTER //
// ./src/actions/components/takeawayWaitingBasket.js